import { Navigate, useLocation, Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";

export function ParticipantRoute() {
  const token = localStorage.getItem("participant_token");
  const loc = useLocation();
  if (!token) return <Navigate to="/login" state={{ from: loc }} replace />;
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <Navbar />
      <Outlet />
    </div>
  );
}

export function AdminRoute() {
  const token = localStorage.getItem("admin_token");
  const loc = useLocation();
  if (!token) return <Navigate to="/admin/login" state={{ from: loc }} replace />;
  return <Outlet />;
}
